import * as React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

import { styled } from '../../../../../../theme';
import { CenterFormOrientation, CenterFormWidget } from '../../../../../../widgets/layout/CenterFormWidget';
import { FormLayoutWidget } from '../../../../../../widgets/layout/FormLayoutWidget';
import { GroupedButtons } from '../../../../../../widgets/buttons/GroupedButtons';
import { ButtonType } from '../../../../../../widgets/buttons/ButtonWidget';
import { useMFAStore } from '../../../../../../hooks/useMFAStore';
import { ConfigureMFANavigationAction, SetupMFASteps } from '../../ConfigureMFADialog';
import { AuthenticatorMFAModel } from '../../../../../../models/AuthenticatorMFAModel';
import { MFABreadCrumb, MFAFormContent } from '../../SharedMFADialogComponents';

export type AuthenticatorConfigureWidgetProps = {
  factorId: string;
  back: ConfigureMFANavigationAction;
  next: ConfigureMFANavigationAction;
  onCancel: ConfigureMFANavigationAction;
};

namespace S {
  const BASE_LABEL = 'authenticator-configure-widget';

  export const QR_CODE_SIZE = 200;

  export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `;

  export const QRCodeContainer = styled.div`
    margin-bottom: 30px;
  `;

  export const QRCode = styled(QRCodeCanvas)`
    border: 20px solid white;
  `;

  export const Message = styled.div`
    label: ${BASE_LABEL}-message;
    font-size: 14px;
    color: ${(p) => p.theme.text.secondary};
    text-align: center;
  `;
}
export const AuthenticatorConfigureWidget: React.FC<AuthenticatorConfigureWidgetProps> = (props) => {
  const mfaStore = useMFAStore();

  const factorModel = mfaStore.item(props.factorId) as AuthenticatorMFAModel;

  return (
    <CenterFormWidget noLogo={true} primaryLabel={'Configure MFA'} orientation={CenterFormOrientation.ROW}>
      <MFABreadCrumb steps={SetupMFASteps} currentStep={1} />
      <FormLayoutWidget
        sections={[
          {
            key: 'content',
            elements: [
              <MFAFormContent key="content">
                <S.Container>
                  <S.QRCodeContainer>
                    <S.QRCode size={S.QR_CODE_SIZE} value={factorModel.factorURI!} />
                  </S.QRCodeContainer>
                  <S.Message>Scan this code using your authenticator app</S.Message>
                </S.Container>
              </MFAFormContent>
            ]
          },
          {
            key: 'buttons',
            elements: [
              <GroupedButtons
                key="buttons"
                btns={[
                  {
                    label: 'Cancel',
                    type: ButtonType.TERTIARY,
                    action: props.onCancel
                  },
                  {
                    label: 'Back',
                    type: ButtonType.SECONDARY,
                    action: props.back
                  },
                  {
                    label: 'Next',
                    action: props.next
                  }
                ]}
              />
            ]
          }
        ]}
      />
    </CenterFormWidget>
  );
};
